(ns authentication.core
  (:require
    [authentication.events]
    [storage.core :as storage]
    [very.re-frame.core :as rf])
  (:import goog.ui.IdleTimer))

(defmulti parser (fn [[op _]] op))

(defmethod parser :set [[_ [key value]]]
  (storage/set (str "carson." (name key)) value))

(defmethod parser :remove [[_ key]]
  (storage/remove (str "carson." (name key))))

(defn session-fx [cfg] (parser cfg))

(defonce listner (atom nil))

(defn inactivity-fx
  "If the user goes X ms without any activity on the page, emit the
  on-expiration event. There is a *very* small chance this is actually
  innacurate, where a user clicks around on the page (or wiggles their mouse,
  etc) for X ms without touching our API (which means the api token will expire
  having not touched the server for a while), but that risk is so fleeting that
  this implementation is good enough. Also, in that event the *very next* user
  event that touches the API will automatically kick them out anyways, they
  just won't get a nice js/alert describing why they were logged out."
  [cfg]
  (assert (every? #(contains? cfg %) [:duration :on-expiration])
          "Invalid inactivity-fx cfg.")
  (assert (nil? @listner) "You can only use one inactivity listner, and one has
                          already been initialized.")
  (let [timer (IdleTimer. (:duration cfg))]
    (reset! listner (.listen timer
                             IdleTimer.Event.BECOME_IDLE
                             #(rf/>evt (:on-expiration cfg))))))
